// Composition identity and recording identity are separate. Release metadata may
// override these defaults with inventory[exactTrackTitle] = {songs: [...], recording: '...'}.
const songAliases={
 'thekingbeetleonthecoconutestate':'thekingbeetleonacoconutestate',
 'auberginetenstories':'aubergine',
 'allahallahallah':'اللهاللهالله',
 'oporcupine':'oporcupine'
};
function songIdentity(title){
 const key=String(title).replaceAll('&#39;',"'").replace(/&/g,' and ')
  .replace(/\([^)]*(?:version|demo|remix|revisited|acoustic|instrumental)[^)]*\)/gi,'')
  .normalize('NFKD').toLowerCase().replace(/[^a-z0-9\u0600-\u06ff]/g,'');
 return songAliases[key]||key;
}
const recordingLinks={
 'east-enders-wives':{'East Enders Wives (Album Version)':'ten-stories::eastenderswives'}
};
function catalogInventory(records){
 const songs=new Set(),recordings=new Set();let incomplete=false;
 for(const r of records){
  const entries=r.trackEntries?.length?r.trackEntries.filter(t=>!t.hidden||!/^Hidden track\b/i.test(t.title)):
   (r.withheld?archiveData[r.id]?.spoiler?.tracks||[]:r.tracks).map(title=>({title}));
  if(!entries.length)incomplete=true;
  for(const entry of entries){
   const title=entry.title,override=r.inventory?.[title]||{};
   // Split only the explicit spaced medley separator, not dates such as 7/29.
   const identities=override.songs||title.split(/\s+\/\s+/).map(songIdentity);
   identities.filter(Boolean).forEach(id=>songs.add(id));
   // Different releases are different recordings unless a specific shared
   // recording is linked. Duplicate entries within one release count once.
   const recording=override.recording||entry.recordingIdentity||recordingLinks[r.id]?.[title]||
    r.id+'::'+title.normalize('NFKD').toLowerCase().replace(/[^a-z0-9\u0600-\u06ff]/g,'');
   recordings.add(recording);
  }
 }
 return {songs:songs.size,recordings:recordings.size,incomplete};
}
